import { useEffect } from 'react';
import { MyAccessibleDoctor } from '../../../bridge/types/doctorProfile';
import { AP } from '../../../pages/types/appointments';
import DoctorFilterStripUi from './FilterStripUi';
import DoctorsList from './DoctorList';
import React from 'react';

const DoctorFilter = ({
    appointments,
    selectedDoctor,
    doctors,
    setSelectedDoctor,
    clinicId,
}: {
    appointments: AP[];
    doctors: MyAccessibleDoctor[];
    selectedDoctor: MyAccessibleDoctor | undefined;
    setSelectedDoctor: (doc: MyAccessibleDoctor | undefined) => void;
    clinicId: string;
}): JSX.Element => {
    useEffect(() => {
        if (selectedDoctor) {
            document.getElementById(`doctor-chip-${selectedDoctor.id}`)?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
    }, [selectedDoctor]);

    if (!doctors || doctors.length < 2) {
        return <></>;
    }

    const doctorsToUseInList = doctors.filter((item) =>
        item.professional.clinics.some((clinic) => clinic._id === clinicId),
    );

    return (
        <div className="space-x-4 z-1 p-16 flex flex-row overflow-x-scroll relative">
            <DoctorFilterStripUi
                aptCount={appointments?.length || 0}
                isSelected={!selectedDoctor}
                onClick={() => setSelectedDoctor(undefined)}
            />
            <DoctorsList
                onSelectDoctorClick={setSelectedDoctor}
                showDoctorAptCount={true}
                doctorsList={doctorsToUseInList}
                selectedDoctor={selectedDoctor}
                appointments={appointments}
            />
        </div>
    );
};

export default DoctorFilter;

export interface TDefaultAvatarProps {
    name: string;
    version: 'small' | 'large';
}
